export default {
  to: "/refund/listing",
  order: 2,
  icon: "payments",
  title: "Student Refund",
  type: "admin",
  disabled: false,
};
